import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { EmployeesPageContent } from "Components/Merchant/Employees/EmployeesPageContent";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";

export const EmployeesPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.Employees)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: null,
      }}
    >
      <StyledPageWrapper maxWidth="unset !important">
        <EmployeesPageContent />
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default EmployeesPage;
